import { Component, OnInit, HostListener, ViewChild, ElementRef, Input } from '@angular/core';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { XlsDownloadService } from 'src/app/shared/xls-download.service';
import { DownloadService } from 'src/app/shared/download.service';
import * as moment from 'moment-timezone';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { InitialState } from "src/app/store/reducer";
import { OpenAdvanceSearchModal } from '../../../../transactions/store/actions';
import {  Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AllowIn, ShortcutInput } from 'ng-keyboard-shortcuts';
import { TabService } from 'src/app/shared/services/tab.service';
import { Tab } from 'src/app/shared/model/tab.model';
import { InvoiceComponent } from 'src/app/transactions/invoice/invoice.component';
import { MsInvoiceComponent } from 'src/app/transactions/invoice/miscellaneous-invoice/ms-invoice/ms-invoice.component';
import { GstInvoiceComponent } from 'src/app/transactions/invoice/miscellaneous-invoice/gst-invoice/gst-invoice.component';
import { V2CreatePaymentComponent } from 'src/app/transactions/payment/v2-create-payment/v2-create-payment.component';
import { V2CreateReceiptComponent } from 'src/app/transactions/receipt/v2-create-receipt/v2-create-receipt.component';
import { CreateAdmAcmComponent } from 'src/app/transactions/adm-acm/create-adm-acm/create-adm-acm.component';
import { AddEntryJvComponent } from 'src/app/transactions/jv/add-entry-jv/add-entry-jv.component';
import { InvoiceRefundComponent } from 'src/app/transactions/invoice-refund/invoice-refund.component';
import * as FileSaver from 'file-saver'; 
import { TourComponent } from 'src/app/transactions/tour/tour.component';
import { EventComponent } from 'src/app/transactions/event/event.component';
import { MiscInvoiceComponent } from 'src/app/transactions/misc-invoice/misc-invoice.component';
import { CookiesService } from 'src/app/shared/cookies.service';
import { AddEntryPurchaseInvoiceComponent } from 'src/app/transactions/purchase-invoice/add-entry-purchase-invoice/add-entry-purchase-invoice.component';
import { ConsolidateInvoiceComponent } from 'src/app/transactions/consolidate-invoice/consolidate-invoice.component';
import { AddEntryContraComponent } from 'src/app/transactions/contra/add-entry-contra/add-entry-contra.component';


@Component({
	selector: 'app-normal-ledger',
	templateUrl: './normal-ledger.component.html',
	styleUrls: ['./normal-ledger.component.scss'],
	providers: [CommonServiceService]
})
export class NormalLedgerComponent implements OnInit {
	@Input() data;
	p = 0;
	q = 0;
	leaderData: any;
	navigationSubscription;
	reInitialise: boolean;
	currentDate = moment().format('YYYY-MM-DD');
	currentTime = moment().format('HH:mm:ss');
	innerHeight: string;
	ascSorttdsAmt: boolean = true;
	ascSortRef: boolean = true;
	totalAmountObj: any;
	// bccEmail: boolean = false;
	// ccEmail: boolean = false;
	showMessage:boolean=false;
	isDownloadScheduled = false;
	alertType:String="";
	message:String=""
	clientData:any
	isAdvancedSearchOpen: boolean = false;
	sendEmailForm:FormGroup
	onSearch;
	onSearchFilter = new Subject<string>();
	parentIndex=0;
	childIndex=0;
	@ViewChild('tableHeader', {static:true}) tableHeader : ElementRef
	@ViewChild('closeSendEmailModal') closebutton;
	@ViewChild('openEmailModal') openEmailModal;
	@ViewChild('openPdfModal', { static: true }) openPdfModal: ElementRef
	account_type: any;
	isPrint: any;
	duration: any;
	allLedgerArr: any;
	ledgerArr: any[] = [];
	shortcuts: ShortcutInput[] = [];
	referenceTypeName = {
		"invoice" : "INVOICE",
		"credit_note" : "Credit Note",
		"jv" : "Journal",
		"consolidate_invoice" : "Consolidate",
		"event_invoice" : "Event",
	}
	waterMark;
	@Input() filters
	dataloaded: any;
	queryParams : any;
	isTenantIndian: boolean = false;
	toSwitchCurrencyCode;
	selectedCurrency: string;
	showOB: boolean = true;

	accounting_company: any;

	constructor(
		private route: ActivatedRoute,
		public commonService: CommonServiceService,
		private router: Router,
		private spinner: NgxSpinnerService,
		private xlsxDownloadService: XlsDownloadService,
		private downloadService: DownloadService,
		private fb:FormBuilder,
		private store: Store<InitialState>,
		private tabService: TabService,
		private cookiesService : CookiesService

	) {
		this.navigationSubscription = this.router.events.subscribe((e: any) => {
			// If it is a NavigationEnd event re-initalise the component
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});

		this.sendEmailForm = this.fb.group({
			toEmails: ["",Validators.required],
			bccEmails: [''],
			ccEmails:[''],
			subject:[''],
			body: ['']
		})

	}
	
	
	ngOnInit() {


		console.log(`TIMESTAMP ngOnInit : `, new Date());
		let queryParams = this.route.queryParams['value']
		this.queryParams = queryParams
		if(this.filters){
			queryParams = this.filters
		}
		let queryData = Object.assign({}, queryParams)

		if(this.data) {
			queryData = this.data
			this.queryParams = queryData;
			if(this.data.bf_balance === false) {
				this.showOB = false
			}
			// queryData['client'] = this.data.account_code
			// queryData['start_date'] = this.data.start_date
			// queryData['end_date'] = this.data.end_date
			// queryData['viewMode'] = this.data.mode
		}
		
		
		if (queryData.client != undefined) {
			localStorage.setItem('activeLedgerQueryParams', JSON.stringify(queryData))
			this.account_type = queryData.account_type
			this.isPrint = queryData.print
			this.getFilteredData(queryData)
		} else {
			this.getData()
		}
		this.onSearchFilter.pipe(
			debounceTime(300),
			distinctUntilChanged())
			.subscribe(value => {
			  this.filterData(value)
		});
		this.reInitialise = true
		let client = JSON.parse(localStorage.getItem("activeLedgerQueryParams")).client
		this.getClient(client)

		this.isTenantIndian = this.commonService.checkTenantIndian()
		if(this.isTenantIndian==false){
			this.getCurrencyCode();
			this.selectedCurrency = 'no';
		}
	}

	ngAfterViewInit() {
		
		this.shortcuts.push(			
			{
				key: "f10",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Open Email Modal",
				description: "Open Email Modal",
				
				command: (e)=>{
					this.openModal()
					setTimeout(() => {
					document.getElementsByTagName('body')[0].click()
					}, 100);
					},
					preventDefault: true
			}
			
	  )
	  console.log(`TIMESTAMP ngAfterViewInit : `, new Date());
	}
	openAdvanceSearchModal(){
		this.store.dispatch(new OpenAdvanceSearchModal({status: true,title : 'ledger'}));	
	}
	
	initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}
	hasSubLedgerTransactions(clientRecord: any): boolean {
		if (!clientRecord?.records?.length) {
			return false;
		}
		return clientRecord.records.some(
			(record) => record.reference_type !== 'opening_balance'
		);
	}

	filterSubLedgersWithTransactions(clientRecords: any[]): any[] {
		return (clientRecords || []).filter((clientRecord) =>
			this.hasSubLedgerTransactions(clientRecord)
		);
	}

	filterData(value) {
		// let tempVariable =  Object.assign([], this.leaderData)
		let tempArr = Object.assign([], this.allLedgerArr)
		if(value.length > 3){
			let lowerCaseFilter = value.toLowerCase()
			let upperCaseFilter = value.toUpperCase()
			this.ledgerArr = tempArr.map(element => {
							let tempEleArr = Object.assign([], element)
					tempEleArr['records'] = tempEleArr['records'].filter(invoiceData =>{
					if (	
							
							(
								invoiceData.narration.join('') != undefined && 
								invoiceData.narration.join('') != null && 
								(	
									invoiceData.narration.join('').toString().includes(value) || 
									invoiceData.narration.join('').toString().includes(upperCaseFilter) ||
									invoiceData.narration.join('').toString().includes(lowerCaseFilter)
								)
							) ||
							(
								invoiceData.date != undefined && 
								invoiceData.date != null && 
								(	
									invoiceData.date.includes(value) || 
									invoiceData.date.includes(upperCaseFilter) ||
									invoiceData.date.includes(lowerCaseFilter)
								)
							) ||
							(
								invoiceData.amount_debit != undefined && 
								invoiceData.amount_debit != null && 
								(	
									invoiceData.amount_debit.toString().includes(value) || 
									invoiceData.amount_debit.toString().includes(upperCaseFilter) ||
									invoiceData.amount_debit.toString().includes(lowerCaseFilter)
								)
							) ||
							(
								invoiceData.amount_credit != undefined && 
								invoiceData.amount_credit != null && 
								(	
									invoiceData.amount_credit.toString().includes(value) || 
									invoiceData.amount_credit.toString().includes(upperCaseFilter) ||
									invoiceData.amount_credit.toString().includes(lowerCaseFilter)
								)
							) ||
							(
								invoiceData.balance != undefined && 
								invoiceData.balance != null && 
								(	
									invoiceData.balance.toString().includes(value) || 
									invoiceData.balance.toString().includes(upperCaseFilter) ||
									invoiceData.balance.toString().includes(lowerCaseFilter)
								)
							) ||
							(
								invoiceData.reference != undefined && 
								invoiceData.reference != null && 
								(	
									invoiceData.reference.includes(value) || 
									invoiceData.reference.includes(upperCaseFilter) ||
									invoiceData.reference.includes(lowerCaseFilter)
								)
							) 
						//Convert Number to string.
	
						) {
							return invoiceData
						}
						console.log("invoiceData",invoiceData)
					})
					console.log("tempEleArr",tempEleArr)
					return tempEleArr
				}

			).filter((element) => this.hasSubLedgerTransactions(element))
		}else{
			this.ledgerArr = []
			for (let i = 0; i <= this.allLedgerArr.length; i++) {
				const element = this.allLedgerArr[i];
				if (element != undefined) {
					this.ledgerArr.push(element)
				}
			}
		}
		console.log("this.ledgerArr",this.ledgerArr)
		

	}
	

	ngOnDestroy() {
		// avoid memory leaks here by cleaning up after ourselves. If we  
		// don't then we will continue to run our initialiseInvites()   
		// method on every navigationEnd event.
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		if (this.leaderData != undefined) {
			this.setHeight(this.p, this.q, event.target.innerHeight)
		}
	}


	//ALL DATA
	getData() {
		this.spinner.show();
		this.commonService.getRequest(`${environment.okountUrl}/reports/ledger`).subscribe(res => {
			this.leaderData = res
			this.accounting_company =  res['company_details'];
			if(res && res['company_details'] && res['company_details'].tenant_logo) {
				this.waterMark = `url('${res['company_details'].tenant_logo}')`
			}
			this.focusOnTableHeader()
			if (this.leaderData != undefined) {
				this.setHeight(0, 0, window.innerHeight)
			}

		}, err => {
			console.error(err)
		})
		this.spinner.hide();
	}


	setHeight(pIndex, innerPIndex, height) {
		if (height == undefined) {
			height = window.innerHeight
		}
		pIndex = Number(pIndex)
		innerPIndex = Number(innerPIndex)
		this.p = pIndex
		this.q = innerPIndex

		let parent = 0
		if (pIndex > 0) {
			parent = pIndex - 1
		}
		let child = 0
		if (innerPIndex > 0) {
			child = innerPIndex - 1
		}
		if (this.leaderData['all_clients_records'].length > 0) {
			// if (this.leaderData['all_clients_records'][parent].client_records.length > 0) {
				if (this.leaderData['all_clients_records'][parent].client_records.length <= 0) {
					// if (this.leaderData['all_clients_records'][parent].client_records[child].records.length <= 4) {
						this.innerHeight = 'auto';
					// }else{
					// 	this.innerHeight = height - 230 + 'px';
					// }
				}
				else {
					this.innerHeight = height - 230 + 'px';
				}
			// }
			// else
			//  {
			// 	this.innerHeight = height - 230 + 'px';
			// }
		}
		else {
			this.innerHeight = height - 230 + 'px';
		}
	}

	downloadPdf(start_date, end_date,display_name) {
		let queryData = this.queryParams;
		this.commonService.downloadPDF(`${environment.okountUrl}/reports/ledger/normal/download`, queryData).subscribe((fileBlob:any) =>{
			let fileName = `${display_name} NORMAL LEDGER FROM ${start_date} TO ${end_date}.pdf` 			
			let blob = new Blob([fileBlob], { 
				type: 'application/pdf'
			});
			FileSaver.saveAs(blob, fileName);
	   })
	} catch (error) {
		console.log('Error occured in getInvoice due to : ', error)
	}

	openSavePdfModal() {

		let recordsLength = this.allLedgerArr.length;
		const fromDate = this.leaderData?.duration?.from_date;
		const toDate = this.leaderData?.duration?.to_date; 
		const display_name= this.leaderData?.all_clients_records[0]?.display_name

		if(recordsLength <= 1500) {
			this.downloadPdf(fromDate,toDate,display_name)
			return;
		} else {
			this.openPdfModal.nativeElement.click()
		}
	}
	
	onYesClickPdfModal() {
		let queryData = JSON.parse(localStorage.getItem('activeLedgerQueryParams'))
		queryData.schedule_download = true;
		const queryParams = queryData;
		 
			this.commonService.getRequestWithPdfData(`${environment.okountUrl}/reports/ledger/normal/download`, queryParams).subscribe((res: any) => {
				this.showMessage = true;
				this.alertType = 'success-box'
				this.message = 'Download Scheduled Successfully.'
				this.onNoClickPdfModal()
				setTimeout(() => {
					this.showMessage = false;
					let redirectUrl = `${environment.baseAccountUrl}/v2/#/report/schedule-reports`
					window.open(redirectUrl, '_blank');
				}, 1000)
			}, err => {
				console.log(err)
			})		
	  }
	  
	  
	onNoClickPdfModal() {
		this.openPdfModal.nativeElement.click()
	}

	//FILTERED DATA
	getFilteredData(queryParams) {
		this.spinner.show()
		this.totalAmountObj ={};
		this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/reports/ledger`, queryParams).subscribe ( res => {
			this.duration = res['duration']
			this.accounting_company =  res['company_details'];
			if(res && res['company_details'] && res['company_details'].tenant_logo) {
				this.waterMark = `url('${res['company_details'].tenant_logo}')`
			}
			this.leaderData = res
			console.log(`TIMESTAMP after fetching data from API : `, new Date());
			const allClientRecords =
				res['all_clients_records'][0]?.client_records ?? [];
			this.allLedgerArr =
				this.filterSubLedgersWithTransactions(allClientRecords);
			this.ledgerArr = [...this.allLedgerArr];
			//  for (let i = 0; i <= this.allLedgerArr.length; i++) {
			// 	const element = this.allLedgerArr[i];
			// 	if (element != undefined) {
			// 		this.commonService.selectedInput.next(1)
			// 		this.ledgerArr.push(element)
			// 	}
			// }
			 
		
			this.focusOnTableHeader()
			if (this.leaderData != undefined) {
				this.totalAmountObj = this.getAmount()
				if(queryParams.print == 'true'){
					this.innerHeight = "auto"
				}else{
					this.setHeight(0, 0, window.innerHeight)
				}
			}
		}, err => {
			console.error(err);
		})
		this.spinner.hide()

	}

	tdsamtSort() {
		this.ascSorttdsAmt = !this.ascSorttdsAmt;
		var testData = this.leaderData;
		this.leaderData.data = testData.data.sort((a, b) => {
			if (this.ascSorttdsAmt) {
				if (b['balance'] < a['balance']) {
					return -1;
				}
				if (b['balance'] > a['balance']) {
					return 1;
				}
				return 0;
			} else {
				if (a['balance'] < b['balance']) {
					return -1;
				}
				if (a['balance'] > b['balance']) {
					return 1;
				}
				return 0;
			}
		});
	}

	refSort() {
		this.ascSortRef = !this.ascSortRef;
		let pIndex = Number(this.p)
		let parent = 0
		if (pIndex > 0) {
			parent = pIndex - 1
		}
		var testData = Object.assign([], this.leaderData['all_clients_records'][parent].client_records)
		for (let index = 0; index < testData.length; index++) {
			const element = testData[index];
			let sortedData = element.records.sort((a, b) => {
				if (this.ascSortRef) {
					if (b['reference'] < a['reference']) {
						return -1;
					}
					if (b['reference'] > a['reference']) {
						return 1;
					}
					return 0;
				} else {
					if (a['reference'] < b['reference']) {
						return -1;
					}
					if (a['reference'] > b['reference']) {
						return 1;
					}
					return 0;
				}
			});
			this.leaderData['all_clients_records'][parent].client_records[index].records = sortedData
		}
	}




	exportAsXLSX(fromDate, toDate): void {
		this.commonService.getOkount(`company/get-all-branch`).subscribe(res => {
			this.spinner.show()
			let xlsxData = [];
			
			this.leaderData['all_clients_records'].forEach(data => {
				
				let balance  = 0
				data['client_records'].forEach(client_record => {
					if(this.queryParams.subledger_type=='All' || this.queryParams.subledger_type=='employee'){
							let nameObj = {};
							nameObj['DATE'] = `CLIENT: ${client_record.aggregated_display_name||''}`
							xlsxData.push(nameObj);
					}
							client_record['records'].forEach(records => {
							let obj = {};
							let i = 0
							let newLineNarration = ''
							if(records.reference_type=='payment' || records.reference_type=='receipt'){
								records.narration.splice(2,1)
							}else{
								records.narration.splice(3,1)
							}
							newLineNarration = records.narration.map(n => n.trim()).join(' | ');
							obj["DATE"] = `${moment(records.date).format('DD/MM/YYYY')}`;
							obj["REFERENCE"] = records.reference;
							obj["NARRATION"] = newLineNarration
							obj['VOUCHER TYPE'] = records.reference_type
							obj["DEBIT"] = records.amount_debit ? Number(Number(records.amount_debit > 0 ? records.amount_debit : records.amount_debit*-1).toFixed(2)) : 0;
							obj["CREDIT"] = records.amount_credit ? Number(Number(records.amount_credit > 0 ? records.amount_credit : records.amount_credit*-1).toFixed(2)) : 0;
							if(this.queryParams.subledger_type=='All' || this.queryParams.subledger_type=='employee'){
								obj['BALANCE'] = Number((balance+ (records.balance ? Number(Number(records.balance).toFixed(2)) : 0)).toFixed(2));
							}else{

								obj['BALANCE'] = records.balance ? Number(Number(records.balance).toFixed(2)) : 0;
							}
							if(records.primary_transaction_no){
								obj['primary Transaction No'] = records.primary_transaction_no ? records.primary_transaction_no: "";
								obj['Primary Company'] = records['primary_tenant_id']?res[records['primary_tenant_id']].company_name:''
							}
							xlsxData.push(obj);
						})
						balance+=client_record['records'].length? (client_record['records'][client_record['records'].length-1].balance ? Number(client_record['records'][client_record['records'].length-1].balance) : 0):0;
						
				});
			
			});
			// xlsxData.push({
			// 	"NARRATION" : "SUB TOTOAL",
			// 	'DEBIT' : this.totalAmountObj.debit? this.totalAmountObj.debit : 0,
			// 	'CREDIT':  this.totalAmountObj.credit? this.totalAmountObj.credit : 0
			// },{
			// 	'NARRATION' : 'CLOSING BALANCE',
			// 	'DEBIT' : this.totalAmountObj.type == 'DR.' ? this.totalAmountObj.diff : 0,
			// 	'VOUCHER TYPE' : 'closing balance',
			// 	'CREDIT': this.totalAmountObj.type == 'CR.' ?  this.totalAmountObj.diff : 0
	
			// })
	
			xlsxData.push({},{},{"DATE":`FROM ${fromDate} TO ${toDate} CLIENT: ${this.leaderData.all_clients_records[0].display_name}`})
	
	
			this.downloadService.exportAsXLSX(`${this.leaderData.all_clients_records[0].display_name} NORMAL LEDGER ${fromDate} - ${toDate}`, xlsxData);
			this.spinner.hide()

		})

	}

	callPdfGeneratorApi(fromDate, toDate) {
		window.scrollTo(0, 0)
		this.spinner.show()
		let url = 'print/account-book/ledger/normal-ledger'
		let queryString = location.hash.split('?')[1]
		if (queryString != undefined) {
			url = `${url}?print=true&${queryString}`
		}
		let printOptions = {
			"landscape": false,
			"format" : "A4",
			"preferCSSPageSize": false
		}
		this.downloadService.callPdfGeneratorApi(`NORMAL LEDGER ${fromDate} - ${toDate}.pdf`, url,printOptions)
		this.spinner.hide()

	}


	
	sendEmails(){
  	
		let toEmails = this.sendEmailForm.value.toEmails
		let bccEmails = this.sendEmailForm.value.bccEmails.split(",")
		let ccEmails = this.sendEmailForm.value.ccEmails.split(",")
		let subject = this.sendEmailForm.value.subject;
		let body = this.sendEmailForm.value.body;
		
		let userData = this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')
		let companyName;
		if(userData && userData['t_tenant_info'] && userData['t_tenant_info']['tenant_company_name']) {
			companyName = userData['t_tenant_info']['tenant_company_name'];
		}
		

		if(toEmails){
		  toEmails = toEmails.split(",")
		  let exclude = ""
		  if(sessionStorage.getItem("excludeArr")){
			  exclude = "&exclude="
			  let excludeArr = JSON.parse(sessionStorage.getItem("excludeArr"))
			  exclude += excludeArr.join(',')
		  }
		  console.log(exclude)
		  window.scrollTo(0, 0)
		  this.spinner.show()
		  let url = 'print/account-book/ledger/normal-ledger'
		  let queryString = location.hash.split('?')[1]
		  if (queryString != undefined) {
			  if(exclude){
				  queryString+=exclude
			  }
			  console.log(queryString)
			  url = `${url}?print=true&${queryString}`
		  }
		  let start_date = JSON.parse(localStorage.getItem("activeLedgerQueryParams")).start_date
		  let end_date  = JSON.parse(localStorage.getItem("activeLedgerQueryParams")).end_date
		  
	
		  let emails = {
			to_addresses:toEmails,
			cc_addresses:ccEmails,
			bcc_addresses:bccEmails
		  }
	  
		  let ledger_criteria = {
			  email:emails,
			  start_date:start_date,
			  end_date:end_date,
			  name:this.clientData.name,
			  email_for:"ledger statement",
			  printOptions : {
				"landscape": false,
				"format" : "A4",
				"preferCSSPageSize": false
			}
		  }
		
		  let data = {
			  page_url: url,
			  ledger_criteria:ledger_criteria,
			  queryParams: this.queryParams,
			  email_body:body,
			  subject:subject
		  }

	  
		  this.commonService.postRequest(`${environment.okountUrl}/ledger/email`,data).subscribe((res : any)=> {
			this.showMessage = true;
			this.alertType = 'success-box'
			this.message = res.msg
			this.closebutton.nativeElement.click();
		  },err => {
			this.showMessage = true
			this.alertType = "error-box"
			this.message = err.msg
			this.closebutton.nativeElement.click();
			
		  })
		}
	  }

	  openModal(){
		//define email.
		this.sendEmailForm.controls.toEmails.setValue(this.clientData.primary_email)
		this.sendEmailForm.controls.bccEmails.setValue("")
		this.sendEmailForm.controls.ccEmails.setValue(this.clientData.secondary_email.split(',').join('\n'))
		
		let userData = JSON.parse(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA'))
		let companyName;
		if(userData && userData['t_tenant_info'] && userData['t_tenant_info']['tenant_company_name']) {
			companyName = userData['t_tenant_info']['tenant_company_name'];
		}
		let subject = `Ledger statement For The Period ${this.duration.from_date ? moment(this.duration.from_date).format('MMMM DD, YYYY') : ''} To ${this.duration.to_date ? moment(this.duration.to_date).format('MMMM DD, YYYY') : ''}`;
		
		let body = `Dear Travel Partner,\n\nPlease find Attached herewith Ledger statement For The Period ${this.duration.from_date ? moment(this.duration.from_date).format('MMMM DD, YYYY') : ''} To ${this.duration.to_date ? moment(this.duration.to_date).format('MMMM DD, YYYY') : ''}`
		body += `\n\nPlease do not hesitate to contact us if you have any query or concern about attached document.\n\nIt's been a pleasure to serve you.\n\nBest Regards\n\n${this.accounting_company?.name?.toUpperCase()}\nAccounts Team`
		if(this.accounting_company && this.accounting_company.telephone){
			body += `\nContact Us on ${this.accounting_company.telephone}`
		}

		this.sendEmailForm.controls.subject.setValue(subject);
		this.sendEmailForm.controls.body.setValue(body)

		this.openEmailModal.nativeElement.click();
	}
	
	
	hideError(){
		this.showMessage = false
	}

	// showCCEmail(){
	// 	this.ccEmail=true;
	// }
	// showBCCEmail(){
	// 	this.bccEmail= true;
	// }

	getClient(value) {
		if (value.length > 2) {
			this.commonService.getOkount(`client/autocomplete?name_like=${value.toUpperCase()}`).subscribe(res => {
					console.log("res:",res)
					this.clientData = res[0]
			}, err => {
				console.log(err)
			})
		}
	}

	



	getAmount() {
		let amountObj = {
			debit: 0,
			credit: 0,
			diff: 0
		}
		let totalCredit = 0
		let totalDebit = 0
		let balance = 0
		let openingBalance = 0
		let openingBalanceType = 'debit'
		if (this.leaderData != undefined) {
			this.leaderData['all_clients_records'].forEach(data => {
				data['client_records'].forEach(client_record => {
					client_record['records'].forEach(records => {
						if(records.reference_type == 'opening_balance'){
							openingBalance += records.amount_debit ? Number(records.amount_debit) : 0;
							if(openingBalance == 0 &&  this.queryParams.subledger_type!='All')	{
										openingBalanceType = 'credit'
									}
										
							openingBalance += records.amount_credit ? Number(records.amount_credit) : 0;				
						}else{
							totalCredit += records.amount_credit ? Number(records.amount_credit) : 0;
							totalDebit += records.amount_debit ? Number(records.amount_debit) : 0;
						}

					});
					if(this.queryParams.subledger_type=='All'||this.queryParams.subledger_type=='employee'){
						balance += client_record['records'].length? (client_record['records'][client_record['records'].length-1].balance ? Number(client_record['records'][client_record['records'].length-1].balance) : 0):0;

					}else{
						

						balance = client_record['records'].length? (client_record['records'][client_record['records'].length-1].balance ? Number(client_record['records'][client_record['records'].length-1].balance) : 0):0;
					}
				});
			});
			if(this.queryParams.subledger_type=='All' || this.queryParams.subledger_type=='employee'){
				openingBalanceType =openingBalance<0?'debit':'credit'
			}
			
			amountObj['credit'] = totalCredit
			amountObj['debit'] = totalDebit
			amountObj['balance'] = balance
			amountObj['diff'] = Number(totalCredit) -(Number(totalDebit) - Number(openingBalance))
			amountObj['openingBalance'] = Number(openingBalance)
			amountObj['openingBalanceType'] = openingBalanceType
			amountObj['type'] = 'CR.'
			if (amountObj['diff'] < 0) {
				amountObj['type'] = 'DR.'
			}
			amountObj['diff'] = Math.abs(amountObj['diff'])
		}
		return amountObj
	}

	openViewMode(reference, referenceType, inv_reference_type) {
		if (reference != undefined) {
			let url = '#/transactions/'
			let viewMode = 'view'
			let isInvoice = false
			let isMisc = false
			let isMsInvoice = false
			let isGstInvoice = false
			let isPayment = false
			let isReceipt = false
			let isAdmAcm = false
			let isEventInvoice = false
			let isJv = false
			let isContra = false
			let isCreditNote = false
			let isTourInvoice = false
			let isPurchaseInvoice = false
			let isConsolidateInovoice = false

			if (referenceType == 'invoice' && inv_reference_type == 'flight_invoice') {
				url = '#/transactions/invoice'
				viewMode = 'view'
				isInvoice = true 
				
			}
			if (referenceType == 'misc-invoice') {
				url = '#/transactions/ms/misc-invoice'
				viewMode = 'view'
				isMisc = true
			}
			if (referenceType == 'invoice' && inv_reference_type == 'event_invoice') {
				url = '#/transactions/event/save/sales'
				viewMode = 'view'
				isEventInvoice = true
			}
			if (referenceType == 'consolidate_invoice') {
				url = `#/transactions/consolidate-invoice/inv/view/${reference}`
				viewMode = 'view'
				isConsolidateInovoice = true
			}
			if (referenceType == 'invoice' && inv_reference_type == 'ms_invoice') {
				url = '#/transactions/ms/ms-invoice'
				viewMode = 'view'
				isMsInvoice = true
			}
			if (referenceType == 'invoice' && inv_reference_type == 'purchase_invoice') {
				viewMode = 'view'
				isPurchaseInvoice = true
			}
			if (referenceType == 'invoice' && inv_reference_type == 'gst_invoice') {
				url = '#/transactions/ms/gst-invoice'
				viewMode = 'view'
				isGstInvoice = true
			}
			if (referenceType == 'invoice' && inv_reference_type == 'tour_invoice') {
				url = '#/transactions/tour/save/sales'
				viewMode = 'view'
				isTourInvoice = true
			}
			if (referenceType == 'credit_note' && inv_reference_type == 'ms_invoice') {
				url = '#/transactions/ms/ms-invoice'
				viewMode = 'view'
				isMsInvoice = true
			}else if (referenceType == 'credit_note' && inv_reference_type == 'tour_invoice') {
				url = '#/transactions/tour/save/sales'
				viewMode = 'view'
				isTourInvoice = true
			} else if (referenceType == 'credit_note' && inv_reference_type == 'purchase_invoice') {
				viewMode = 'view'
				isPurchaseInvoice = true
			}else if (referenceType == 'credit_note') {
				url = '#/transactions/credit-note'
				viewMode = 'view'
				isCreditNote =  true
			}
			if (referenceType == 'payment') {
				url = '#/transactions/payment'
				viewMode = 'view'
				isPayment = true
			}
			if (referenceType == 'receipt') {
				url = '#/transactions/receipt'
				viewMode = 'view'
				isReceipt = true
			}
			if (referenceType == 'jv') {
				url = '#/transactions/jv'
				viewMode = 'update'
				isJv = true
			}
			if (referenceType == 'contra') {
				url = '#/transactions/contra'
				viewMode = 'update'
				isContra = true
			}
			if (referenceType == 'adm' || referenceType == 'acm') {
				url = '#/transactions/adm-acm'
				viewMode = 'view'
				isAdmAcm = true
			}
			
			let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}${url}/${viewMode}/${reference}`
			if(window.location.protocol != 'file:'){
				    let title =''
				    let referenceSplit = reference.split('-')
					title += referenceSplit[0]
					title +='...'
					title += referenceSplit[referenceSplit.length-1]
				    if(isInvoice) {
						this.tabService.addTab(
							new Tab(InvoiceComponent, `${title}`, { invoice: reference ,mode : 'view' },reference)
							);
					}else if(isMisc) {
						this.tabService.addTab(
							new Tab(MiscInvoiceComponent, `${title}`, { invoice: reference , mode : 'view' }, reference)
							);
					} else if(isMsInvoice) {
						this.tabService.addTab(
							new Tab(MsInvoiceComponent, `${title}`, { invoice: reference , mode : 'view' }, reference)
							);
					} else if(isConsolidateInovoice) {
						this.tabService.addTab(
							new Tab(ConsolidateInvoiceComponent, `${title}`, { invoice: reference , mode : 'view' }, reference)
							);
					} else if(isPurchaseInvoice) {
						this.tabService.addTab(
							new Tab(AddEntryPurchaseInvoiceComponent, `${title}`, { invoice: reference ,mode : 'view' }, reference)
							);
					} else if(isCreditNote) {
						this.tabService.addTab(
							new Tab(InvoiceRefundComponent, `${title}`, { creditNoteNumber: reference, mode : 'view' }, reference)
						);
					} else if(isGstInvoice) {
						this.tabService.addTab(
							new Tab(GstInvoiceComponent, `${title}`, { invoice: reference ,mode : 'view' }, reference)
							);
					} else if(isPayment) {
						this.tabService.addTab(
							new Tab(V2CreatePaymentComponent, `${title}`, { paymentRef: reference ,mode : 'view' }, reference)
							);
					}
					else if(isReceipt) {
						this.tabService.addTab(
							new Tab(V2CreateReceiptComponent, `${title}`, { receiptRef: reference ,mode : 'view' }, reference)
							);
					} else if(isAdmAcm) {
						this.tabService.addTab(
							new Tab(CreateAdmAcmComponent, `${title}`, { adm_acm_number: reference, mode : 'view' }, reference)
						);
					} else if(isJv) {
						this.tabService.addTab(
							new Tab(AddEntryJvComponent, `${title}`, { jv_code: reference }, reference)
							);
					} else if(isContra) {
						this.tabService.addTab(
							new Tab(AddEntryContraComponent, `${title}`, { contra_code: reference }, reference)
							);
					} else if(isTourInvoice) {
						this.tabService.addTab(
							new Tab(TourComponent, `${title}`, { invoice: reference , mode : 'view' }, reference)
							);
					} else if(isEventInvoice) {
						this.tabService.addTab(
							new Tab(EventComponent, `${title}`, { invoice: reference , mode : 'view' }, reference)
							);
					} else {
						window.open(path,'_blank')		
				}
			}else{
				var customeEventHandler = new CustomEvent("handle-window-open", {
					"detail": {
						hashPath : path
					}
				  });
				window.dispatchEvent(customeEventHandler)

			}
		}
	}

	// keyboard integration
	// Add #tableHeader on table header

	focusOnTableHeader() :void{
		if (this.tableHeader != undefined) {
			this.tableHeader.nativeElement.focus()
		}
	}

	onKeyDown(e: any) {
		console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
		if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false) {
			if (e.keyCode == 40) {
				e.preventDefault();
				this.moveToNext()
			} else if (e.keyCode === 38) {
				e.preventDefault();
				this.moveToPrev()
			}
		}
	}
	moveToNext(){
		if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex+1}`) != null) {
			document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex+1}`).focus()
			this.childIndex = this.childIndex+1
		}else{
			if (this.parentIndex < this.ledgerArr.length - 1) {
				this.parentIndex = this.parentIndex+1
				this.childIndex = -1
			}
			if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex+1}`) != null) {
				document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex+1}`).focus()
				this.childIndex = this.childIndex+1
			}else if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex}`) != null) {
				document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex}`).focus()
				this.childIndex = this.childIndex+1
			}
		}
	}
	moveToPrev(){
		if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex-1}`) != null) {
			document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex-1}`).focus()
			this.childIndex = this.childIndex-1
		}else{
			if (this.parentIndex > 0) {
				this.parentIndex = this.parentIndex-1
				if (this.ledgerArr[this.parentIndex] != undefined) {
					this.childIndex = this.ledgerArr[this.parentIndex].records.length
				}
			}else{
				this.childIndex = 0
			}
			if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex-1}`) != null) {
				document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex-1}`).focus()
				if (this.childIndex >0) {
					this.childIndex = this.childIndex-1
				}
			}else if (document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex}`) != null) {
				document.getElementById(`rowIndex_${this.parentIndex}_${this.childIndex}`).focus()
				if (this.childIndex >0) {
					this.childIndex = this.childIndex-1
				}
			}
		}
	}
	
	moveToIndex(parentIndex,childIndex){
		document.getElementById(`rowIndex_${parentIndex}_${childIndex}`).focus()
		this.parentIndex = parentIndex
		this.childIndex = childIndex
	}

	dataLoadedFn(i){
		if(!this.dataloaded){
			this.dataloaded = true
			try {
				setTimeout(() => {
					document.querySelector("#print-section") ? document.querySelector("#print-section").classList.add("voucher-container") : null
				}, 1000);
			} catch (error) {
				
			}
		}
	}

	changeLedgerAmount(event) {
		let queryParams = this.route.queryParams['value'];
		let queryData = Object.assign({}, queryParams);

		if(event.target.value == 'yes') {
			queryData['switch_currency'] = true;
		}else {
			queryData['switch_currency'] = false;
		}
		this.queryParams = queryData;
		if(queryData.client != undefined && event.target.value) {
			this.getFilteredData(queryData)
		}
	}

	getCurrencyCode() {
		let queryData = this.queryParams;
		this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/reports/ledger/currency`, queryData).subscribe(res => {
			if(res && res['currency']) {
				this.toSwitchCurrencyCode = res['currency'];
			}
		}, err => {
			console.error(err)
		})

	}

}

